<template>
  <b-modal id="modal-signup" size="size-signup" hide-footer hide-header no-close-on-backdrop no-close-on-esc centered
           modal-class="modal-mobile-fullscreen modal-sign-up">
    <div class="d-block text-center mt-1 mt-lg-3 mb-3 logo">
      <img :src="$store.getters['appConfig/getAppLogo']" class="img-fluid" alt="Logo">
    </div>
    <div class="d-block text-center">
      <h1 class="modal-title pb-2">
        {{ eventName ? eventName : $t('pages.preview.signup_modal_title') }}
      </h1>
      <h4 class="modal-subtitle-sign pb-4">
        <span v-if="$store.state.appConfig.loginSubtitle" v-html="$store.state.appConfig.loginSubtitle"></span>
        <span v-else>{{ $t('pages.signup.headline_txt') }}</span>
        <span><router-link :to="{ name: 'login' }" exact
                           class="p-2 text-primary link-login">{{ $t('forms.signup_form.btn_login') }}</router-link></span>
      </h4>
    </div>
    <div class="d-block">
      <SignupForm/>
    </div>
  </b-modal>
</template>

<script>
import SignupForm from '@/components/SignupForm'

export default {
  props: ['eventName'],
  components: {
    SignupForm
  }
}
</script>
